import React, { useEffect, useState, useRef } from "react";
import ReactLoading from "react-loading";
import { useAlert } from "react-alert";
import { useHistory } from "react-router-dom";
import auth from './auth';
import Form from 'react-bootstrap/Form';
import { PinNumberPage } from './PinNumberPage';
import { MobileNumberPage } from './MobileNumberPage';
import BlueLogo from "../Resources/logo-blue.png"

export const VisitorSignUp = (props) => {
  const [firstName, setFirstName] = useState("");
  const [currentPage, setCurrentPage] = useState("mobileNumberPage");
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [emailValidation, setEmailValidation] = useState(true);
  const [mobileValidation, setMobileValidation] = useState(true);
  const [occupationValidation, setOccupationValidation] = useState(true);
  const [globalFormValidation, setGlobalFormValidation] = useState(false);
  const [occupation, setOccupation] = useState("");
  const [gender, setGender] = useState("");
  const [displayCustomOccupation, setDisplayCustomOccupation] = useState(false);
  const [occupations, setOccupations] = useState([]);
  const [notLoading, setNotLoading] = useState(true);
  const [pinNumber, setPinNumber] = useState("");
  const [pinFailCounter, setPinFailCounter] = useState(0);
  const [dobFailCounter, setDobFailCounter] = useState(0);
  const [triggerID, setTriggerID] = useState(0);
  const textInputRef = useRef(null);
  //const queryString = window.location.search;
  //const urlParams = new URLSearchParams(queryString);
  const docketNumber = props.entry;
  const venue = props.venue
  const alert = useAlert();
  const history = useHistory();
  const [timerCountdown, setTimerCountdown] = useState(0);
  const timerRef = useRef(null);
  //We need this to set Max date in the dob input to ensure member is over 18
  const maxBdayDate = new Date(
    new Date().setFullYear(new Date().getFullYear() - 18)
  )
    .toISOString()
    .split("T")[0];

  /**
   * This function is calling the signUp controller and create a member account
   */
  async function submitForm(ev) {
    ev.preventDefault();
    const personalDetails = {
      email,
      mobilePhone: mobileNumber,
      jobTitle: occupation,
      gender,
      dob: dateOfBirth,
    };

    const DTO = {
      dob: dateOfBirth,
      personalDetails,
      memberVenue: venue,
      docketNumber,
      pinNumber,
    };

    try {
      setNotLoading(false);

      const response = await fetch(
        localStorage.getItem("server") + "/api/app/dayslipSignUp",
        {
          method: "POST",
          body: JSON.stringify(DTO),
        }
      );

      const data = await response.json();

      if (data.status === 200) {
        resetTimeOut();
        setPinNumber("");
        alert.show(
          "Congratulations! You are now a member of Bankstown Sports Club. You will soon receive a confirmation email.",
          {
            title: "Success",
          }
        );

        setTimeout(() => {
          history.push("");
        }, 900);
      } else  {
        alert.show(data.message + ". Please try again", {
          title: "Error",
        });
        resetTimeOut();
        resetPin();
        setCurrentPage("moreInfoPage");
      }
    } catch (exception) {
      console.error(exception);
    } finally {
      setNotLoading(true);
    }
  }

  /**
   * This useEffect is purely to determine whether the submit button should be disabled or not
   */
  useEffect(() => {

    if(mobileValidation && emailValidation && email !== '' && mobileNumber !== '' && gender !== '' && occupation !== '' && occupationValidation){
      setGlobalFormValidation(true);
    }
    else {
      setGlobalFormValidation(false);
    }

  }, [emailValidation, mobileValidation, email, mobileNumber, gender, occupation, occupationValidation])


  useEffect(() => {
    if(docketNumber){
      history.push({
        pathname: "/dayslipSignUp",
        state: {
          docketNumber: props.entry,
          venue: props.venue,
        },
      });
    }
  }, [])

  const validateEmail = (emailInput) => {
    setEmail(emailInput);

    if(String(emailInput)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )){
        setEmailValidation(true);
      }
      else {
        setEmailValidation(false);
      }

  };

  const validateMobileNumber = (number) => {
    setMobileNumber(number);

    if( String(number)
    .match(/^[0][4][0-9]{8}/)){
      setMobileValidation(true);
    }
    else {
      setMobileValidation(false);
    }
    
  }

  const validateOccupation = (text) => {
    setOccupation(text);

    const occupationWithoutSpace = text.replace(/\s/g, '');

    if(occupationWithoutSpace.length < 2){
      setOccupationValidation(false);
    }
    else {
      setOccupationValidation(true);
    }
  }

  async function fetchOccupationsList() {
    const response = await fetch(
      localStorage.getItem("server") + "occupations"
    );

    const data = await response.json();

    if (data.status === 200) {
      setOccupations(data.data);
    }
  }

  useEffect( () => {
    if(pinNumber.length === 6){
      confirmOTP();
    }
  }, [pinNumber])

  async function fetchUserDetails() {
    setNotLoading(false);

    const response = await fetch(
      localStorage.getItem("server") + "visitorQR/" + docketNumber + "/" + venue
    );

    const data = await response.json();

    if (data.status === 200) {
      setFirstName(data.data);
    }
  }

  async function confirmOTP(){

    setNotLoading(false);

    const DTO =  { mobileNumber, pinNumber, memberNumber: null, dob: dateOfBirth };

    try{
      const response = await fetch(
        localStorage.getItem("server") + "otpLogin",
        {
          method: "POST",
          headers: {
            regoID: 3,
          },
          body: JSON.stringify(DTO),
        }
      );

      const data = await response.json();

      if (data.status === 401) {
        if(pinFailCounter < 3){
          alert.show("Your request cannot be processed. Please check whether the verification code you provided was correct and try again.", {
            title: "ERROR"
          });
        }
        else {
          alert.show("You have reached the maximum attempt to confirm your verification code. Please try again later or contact us at 9722 9888.", {
            title: "ERROR"
          });

          setTimeout(() => {
            window.location.reload();
          },2000)
        }
        const counter = pinFailCounter + 1;
        setPinFailCounter(counter);
      }
      else if (data.status === 200){
          setCurrentPage('dobPage');
          setTriggerID(data.triggerID);
      } 
      else{
        alert.show("Your request currently cannot be processed. Please try again later.", {
          title: "ERROR"
        });
        history.push("/home");
      }
    }
    catch (exception){
      console.error(exception);
    }
    finally {
      setNotLoading(true);
    }
  }

  async function activatePinPage(){
    let timeOutInMiliseconds = Date.now() + 300000;
    setTimerCountdown(timeOutInMiliseconds);
    setCurrentPage('pinPage');
  }


  function errorAlert(){
    alert.show("Your request currently cannot be processed. Please check if the information your provided was correct and try again.", {
        title: "ERROR"
      });
  }

  async function generateOTP(ev) {
    ev.preventDefault();

    if(mobileValidation){
    sessionStorage.setItem("mobileNumber", mobileNumber);
    setNotLoading(false);
      try {
        await auth.generateOTP(mobileNumber, activatePinPage, errorAlert, 3)
      } catch (exception) {
        console.error(exception);
        alert.show("Your request currently cannot be processed. Please try again.", {
          title: "An error has occured"
        });
      } 
      finally{
        setNotLoading(true);
        const timer = Date.now() + 300000;
        setTimerCountdown(timer);
      }
    }
  }

  async function confirmDob(event) {
    event.preventDefault();
    if (dobFailCounter === 4) {
      alert.show(
          "You have exceeded the number of allowed attempts for validating your birthday. Please start again.",
        {
          title: "An error has occured",
        }
      );
      setTimeout(() => {
        history.push('');
      }, 900)
    } else {
      try {
        const DTO = { dateOfBirth, docketNumber, venue, triggerID };

        const response = await fetch(
          localStorage.getItem("server") + "confirmDOB",
          {
            headers: {regoID: 3},
            method: "POST",
            body: JSON.stringify(DTO),
            
          }
        );

        const data = await response.json();
        console.log(data);

        if (data.status === 200) {
          switch(data.code){

            case 0:
              setCurrentPage("moreInfoPage");
              break;
            
            case 1:
              //we have found your membership
              alert.show(
                "Congratulations! We have found your membership details. Your member number is: " + data.memberNumber,
                {
                  title: "Success",
                }
              );

              sessionStorage.setItem('memberNumber', data.memberNumber);
              sessionStorage.setItem("loggedIn", true);
              sessionStorage.setItem("token", data.token);
    
      
              setTimeout(() => {
                history.push("/home");
              }, 1000);
              break;

            default:
              alert.show(
                "We were unable to sign you up as we have found multiple memberships associated with the details you entered. Please contact us at 9722 9888",
                {
                  title: "Uh oh",
                }
              );
      
              setTimeout(() => {
                history.push("");
              }, 900);
              break;
          }

         
        } else {
          setDobFailCounter((dobFailCounter) => dobFailCounter + 1);
          alert.show("Please check your date of birth to continue", {
            title: "Error",
          });
        }
      } catch (exception) {
        console.error(exception);
      }
    }
  }

 

  function resetTimeOut() {
    clearTimeout(timerRef.current);
    setPinFailCounter(0);
  }

  /**
   * This function reset the occupation to '', and toggle the custom occupation
   */
  const resetOccupation = () => {
    setOccupation("");
    setDisplayCustomOccupation(!displayCustomOccupation);
  };

  function resetPin() {
    textInputRef.current.value = "";
    setPinNumber("");
  }

  useEffect(() => {
    async function initialFetch() {
      try {
        await fetchOccupationsList();
        await fetchUserDetails();
      } catch (exception) {
        console.error(exception);
        alert.show("Unable to retrieve details, please try again", {
          title: "ERROR",
        });
      } finally {
        setNotLoading(true);
      }
    }
    initialFetch();
  }, []);

  useEffect(() => {
    if (occupation === "Other (must specify)") {
      setOccupationValidation(false);
      resetOccupation();
    }
  }, [occupation]);


  return (
    <div className="mini-form">
      <img alt="Bankstown Logo" className="oauth-image" src={BlueLogo} />
      <h2>
        <strong>REGISTER</strong>
      </h2>
      <div></div>
      <div className="overlay" hidden={notLoading}>
        <ReactLoading
          className="loading"
          type={"cylon"}
          color={"#61dafb"}
          height={300}
          width={300}
        />
      </div>
      {currentPage === "pinPage" && (
      <PinNumberPage timerCountdown={timerCountdown} pinNumber={pinNumber} setPinNumber={setPinNumber}/>
      )}
      {currentPage === "dobPage" && firstName && (
        <div>
          <p className="text-center">
            Hi {firstName}! We just want to confirm it's you - please enter your
            date of birth
          </p>
          <Form onSubmit={(ev) => confirmDob(ev)}>
            <label className="login-label">
              <strong>Date of Birth</strong>
            </label>
            <br />
            <input
              autoFocus
              name="dateOfBirth"
              className="formInput"
              type="date"
              max={maxBdayDate}
              onChange={(ev) => setDateOfBirth(ev.target.value)}
            />
            <button
              className="mini-form text-center form-btn btn btn-primary d-flex justify-content-center"
              type="submit"
            >
              Next
            </button>
          </Form>
        </div>
      )}
      {currentPage === "mobileNumberPage" && firstName && (
        <div>
          <p className="text-center">
            Hi {firstName}! We just want to confirm it's you!
          </p>
          <MobileNumberPage mobileNumber={mobileNumber} setMobileNumber={setMobileNumber} generateOTP={generateOTP}/>
        </div>
      )}
      {currentPage === "moreInfoPage" && (
        <div className="needs-validation">
          <p className="text-center">We just need few more details from you</p>
          <Form onSubmit={(event) =>submitForm(event)}>
            <div>
              <p></p>
              <label className="login-label" for="form-validation-email">
                <strong>Email *</strong>
              </label>
              <br />
              <input
                autoFocus
                id="form-validation-email"
                name="email"
                value={email}
                className="formInput form-control"
                type="email"
                onChange={(ev) => validateEmail(ev.target.value)}
              />
              {!emailValidation && 
                <p className="input-validation-message">
                  Please enter a valid email address.
                </p>
                }
            </div>
            <div className="login-label">
              <label className="login-label">
                <strong>Occupation *</strong>
              </label>
              {displayCustomOccupation ? (
                <div className="relative">
                  <input
                    type="text"
                    value={occupation}
                    placeholder="Enter Occupation"
                    className="formInput form-control"
                    onChange={(ev) => validateOccupation(ev.currentTarget.value)}
                  />
                  <button
                    className="btn btn-outline-dark occupation-back-btn-dayslip"
                    onClick={(ev) => {
                      resetOccupation(ev);
                      setOccupationValidation(false);
                    }}
                  >
                    X
                  </button>
                </div>
              ) : (
                <select
                  className="formInput form-control"
                  onChange={(ev) =>{ 
                    validateOccupation(ev.currentTarget.value); 
                    setOccupationValidation(true);
                  }
                  }
                >
                  <option value="" disabled={true} selected>
                    Select Occupation
                  </option>
                  {occupations.map((occupationObj, index) => (
                    <option key={index} value={occupationObj.name} selected={!displayCustomOccupation && (occupationObj.name === occupation)}>
                      {occupationObj.name}
                    </option>
                  ))}
                </select>
              )}
               {!occupationValidation && 
                <p className="input-validation-message">
                  Please enter a valid occupation
                  </p>
              }
            </div>
            <div>
              <label className="login-label">
                <strong>Gender *</strong>
              </label>
              <br />
              <select
                className="formInput form-control"
                value={gender}
                name="gender"
                onChange={(ev) => {
                  setGender(ev.currentTarget.value);
                }}
              >
                <option value="" hidden>
                  Please Select
                </option>
                <option value="1">Male</option>
                <option value="2">Female</option>
                <option value="3">Non-Binary/Gender Fluid</option>
              </select>
            </div>

            <button
              className="mini-form text-center form-btn btn btn-primary d-flex justify-content-center"
              type='submit'
              disabled = {!globalFormValidation ? true : false}
            >
              Submit
            </button>
          </Form>
        </div>
      )}
    </div>
  );
};
